function getDataFromIntelligems() {
  const excludedCountries = [];
  const onlyForCountries = [];
  const offeredProductIds = [];
  const utmParams = [];

  try {
    if (!window.igData || !window.igData.campaigns || typeof window.igData.campaigns.getAll !== 'function') {
      console.warn('Intelligems data not available');
      return [];
    }

    const campaigns = window.igData.campaigns.getAll();

    if (!Array.isArray(campaigns)) {
      console.warn('Campaigns is not an array');
      return [];
    }

    campaigns.forEach((campaign) => {
      const campaingProducts = campaign.discount.offerProducts;
      campaingProducts.forEach((product) => {
        if (product?.id) {
          offeredProductIds.push(product.id);
        }
      });

      const filters = campaign?.discount?.experience?.audience?.filters;
      if (!Array.isArray(filters)) {
        return;
      }

      filters.forEach((filter) => {
        const expression = filter?.expression;
        if (!Array.isArray(expression)) {
          return;
        }
        const filterType = filter.filterType;
        console.log('filterType:', filterType);

        // country filter
        if (filterType === 'utm') {
          // Check if expression contains an operator item (e.g., "or")
          const operatorItem = expression.find((item) => item?.operator);
          const queryItems = expression.filter((item) => item?.query);

          if (operatorItem && queryItems.length > 1) {
            // Combine query values with | separator (e.g., "blackfridayearlyaccess|BFCM")
            const combinedValue = queryItems.map((item) => item.query.value).join('|');
            const firstQuery = queryItems[0].query;
            utmParams.push({
              key: firstQuery.key,
              value: combinedValue,
            });
          } else {
            queryItems.forEach((filterExpression) => {
              const query = filterExpression?.query;
              if (query && query.type && query.value) {
                utmParams.push({
                  key: query?.key,
                  value: query?.value,
                });
              }
            });
          }
        } else if (filterType === 'country') {
          expression.forEach((filterExpression) => {
            const query = filterExpression?.query;
            if (query?.type === 'country' && query?.value) {
              if (query?.filter === 'doesNotEqual') {
                excludedCountries.push(query.value);
              } else if (query?.filter === 'equals') {
                onlyForCountries.push(query.value);
              }
            }
          });
        }
      });
    });

    return { excludedCountries, offeredProductIds, utmParams, onlyForCountries };
  } catch (error) {
    console.error('Error getting excluded countries from Intelligems:', error);
    return { excludedCountries: [], onlyForCountries: [], offeredProductIds: [], utmParams: [] };
  }
}

function hasValidUtmParams(utmParams) {
  const urlParams = new URLSearchParams(window.location.search);

  if (utmParams.length && urlParams.size === 0) return false;

  return utmParams.every(function (param) {
    const urlValue = urlParams.get(param.key);
    if (!urlValue) return false;
    if (param.value.includes('|')) {
      return param.value.split('|').includes(urlValue);
    }
    return urlValue === param.value;
  });
}

// Formats discounted cents the same way the price text is written ("$35.00 USD", "35,00 €" ...).
function formatDiscountedPrice(priceText, discountedCents) {
  const currencyPrefix = priceText.match(/^[^\d.,\s]+/)?.[0]?.trim() || '';
  const currencySuffix = priceText.match(/[^\d.,\s]+$/)?.[0]?.trim() || '';
  const isEUR = currencyPrefix === '€' || currencySuffix === 'EUR';
  const isUSD = currencyPrefix === '$' || currencySuffix === 'USD';

  const value = discountedCents / 100;
  const parts = value.toFixed(2).split('.');

  if (isEUR) {
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `€${intPart},${parts[1]}${currencySuffix ? ' ' + currencySuffix : ''}`;
  } else if (isUSD) {
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `$${intPart}.${parts[1]}${currencySuffix ? ' ' + currencySuffix : ''}`;
  }
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${currencyPrefix}${intPart},${parts[1]}${currencySuffix ? ' ' + currencySuffix : ''}`;
}

// ---- Yagi app block (product page) ----------------------------------------
// On the PDP the price shoppers actually see – and its "10% off" badge – comes
// from the Yagi app block (.shopify-app-block .yagi-price-container); Yagi hides
// the theme's own price. When an Intelligems offer applies, that block has to
// show the offer's percentage and price instead of Yagi's own.
const nsdYagiOverrides = {}; // productId -> { value }
const nsdYagiObserved = {}; // productId -> true

function nsdYagiBlock() {
  return document.querySelector('.shopify-app-block .yagi-price-container');
}

function nsdApplyYagiOverride(productId) {
  const override = nsdYagiOverrides[productId];
  if (!override) return false;

  // Only touch the Yagi block on the page of the product the offer is for.
  const pageProductId = window.ShopifyAnalytics?.meta?.product?.id;
  if (pageProductId && String(pageProductId) !== String(productId)) return false;

  const container = nsdYagiBlock();
  if (!container) return false;

  const pct = Math.round(override.value * 100);

  const badge = container.querySelector('.yagi-sale-badge');
  if (badge) {
    const current = badge.textContent.trim();
    const next = /\d+(?:[.,]\d+)?\s*%/.test(current)
      ? current.replace(/\d+(?:[.,]\d+)?\s*%/, `${pct}%`)
      : `${pct}% off`;
    if (current !== next) badge.textContent = next;
  }

  // Keep the discounted price in step with the badge (selected variant's price).
  const priceEl = document.querySelector(`[id^="price-"] [data-product-price-regular][data-product-id="${productId}"]`);
  const discounted = container.querySelector('.yagi-discounted-price');
  if (priceEl && discounted) {
    const cents = parseInt(priceEl.getAttribute('data-product-price-regular'), 10);
    if (!isNaN(cents)) {
      const next = formatDiscountedPrice(priceEl.textContent.trim(), Math.ceil(cents * (1 - override.value)));
      if (discounted.textContent.trim() !== next) discounted.textContent = next;
    }
  }
  return true;
}

// Yagi re-renders its block on variant change – keep the override on top of it.
function nsdObserveYagi(productId) {
  if (nsdYagiObserved[productId]) return;
  nsdYagiObserved[productId] = true;

  let tries = 0;
  function attach() {
    const block = nsdYagiBlock()?.closest('.shopify-app-block');
    if (!block) {
      // the app block may render after this script runs
      if (++tries < 25) setTimeout(attach, 200);
      return;
    }

    nsdApplyYagiOverride(productId);

    let windowStart = Date.now();
    let runs = 0;
    const observer = new MutationObserver(() => {
      // safety net: never fight another script in a tight loop
      if (Date.now() - windowStart > 2000) {
        windowStart = Date.now();
        runs = 0;
      }
      if (++runs > 30) {
        observer.disconnect();
        return;
      }
      nsdApplyYagiOverride(productId);
    });
    observer.observe(block, { childList: true, subtree: true, characterData: true });
  }
  attach();
}

// An Intelligems offer (applyOfferDiscount) replaces Yagi's badge percentage.
// If several offers apply to the same product the biggest discount is shown, so
// the result doesn't depend on the order the offers run in.
function overrideYagiDisplay(productId, discountValue) {
  const id = String(productId);
  const existing = nsdYagiOverrides[id];
  if (existing && existing.value >= discountValue) return;

  nsdYagiOverrides[id] = { value: discountValue };
  nsdObserveYagi(id);
  nsdApplyYagiOverride(id);
}

function renderAutoDiscountedPrice(productId, discountValue) {
  // On the PDP the visible price + badge is Yagi's block – override that too.
  overrideYagiDisplay(productId, discountValue);

  function applyDiscount() {
    const priceEls = document.querySelectorAll(`[data-product-price-regular][data-product-id="${productId}"]`);

    priceEls.forEach((el) => {
      const priceContainer = el.closest('.price__container');
      if (!priceContainer) return;

      if (priceContainer.querySelector('.yagi-price-container')) return;

      const priceInCents = parseInt(el.getAttribute('data-product-price-regular'), 10);
      if (isNaN(priceInCents)) return;

      const priceText = el.textContent.trim();
      const discountedCents = Math.ceil(priceInCents * (1 - discountValue));

      const yagiHtml = `
        <div class="yagi-price-container">
          <span>
            <s class="price-item price-item--regular yagi-original-price">
              ${priceText}
            </s>
          </span>
          <span class="price-item price-item--sale price-item--last yagi-discounted-price">
            ${formatDiscountedPrice(priceText, discountedCents)}
          </span>
        </div>
      `;

      const priceRegular = priceContainer.querySelector('.price__regular');
      const priceSale = priceContainer.querySelector('.price__sale');
      if (priceRegular) priceRegular.style.display = 'none';
      if (priceSale) priceSale.style.display = 'none';

      priceContainer.insertAdjacentHTML('beforeend', yagiHtml);
    });
  }

  applyDiscount();

  const priceSection =
    document.querySelector(`#price-template--${productId}__main`) ||
    document.querySelector(`[data-product-id="${productId}"]`);

  if (priceSection) {
    const observer = new MutationObserver(() => {
      applyDiscount();
    });

    observer.observe(priceSection, {
      childList: true,
      subtree: true,
    });
  }
}

function applyOfferDiscount(offerId, discountValue) {
  if (!offerId || !discountValue) return;

  const offers = igData?.offers?.getAll();
  if (!offers || !offers.length) return;

  const offer = offers.find((offer) => offer.id === offerId);
  if (!offer?.offer?.offerProducts) return;

  const offerProducts = offer.offer.offerProducts;

  offerProducts.forEach((product) => {
    const productId = product?.productId || product?.id || product;
    if (!productId) return;
    renderAutoDiscountedPrice(String(productId), discountValue);
  });
}
